import React, { Suspense } from "react";
import PropTypes from "prop-types";
import RouteEnum from "../../constants/RouteEnum";
import Toasts from "../components/common/toasts/Toasts";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import Login from "views/pages/Login/Login";
import Extractpdf from "views/pages/Extractpdf/Extractpdf";
import InvoiceContent from "views/pages/Invoice/InvoiceContent";
import AcceptInvitation from "views/pages/InviteSignup/AcceptInvitation";
import ForgotPassword from "views/pages/PasswordReset/ForgotPassword";
import VerifyPasswordReset from "views/pages/PasswordReset/VerifyPasswordReset";
import ResetPassword from "views/pages/PasswordReset/ResetPassword";
import MfaRecovery from "views/pages/MfaRecovery/MfaRecovery";
import AdminUsers from "views/pages/AdminUsers/AdminUsers";
import { PublicOnly, RequireAdmin, RequireAuth } from "./AuthGuards";
export const RouteRegisterer = () => {
  const { t } = useTranslation();

  return (
    <Spin spinning={false} tip={t("loading")} className="spin-loading">
      <Router>
        <Suspense
          fallback={<Spin spinning tip={t("loading")} className="spin-loading" />}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route element={<PublicOnly />}>
              <Route path={RouteEnum.Login} element={<Login />} />
              <Route path={RouteEnum.ForgotPassword} element={<ForgotPassword />} />
              <Route path={RouteEnum.VerifyPasswordReset} element={<VerifyPasswordReset />} />
              <Route path={RouteEnum.ResetPassword} element={<ResetPassword />} />
              <Route path={RouteEnum.AcceptInvitation} element={<AcceptInvitation />} />
              <Route path={RouteEnum.MfaRecovery} element={<MfaRecovery />} />
            </Route>
            <Route element={<RequireAuth />}>
              <Route path={RouteEnum.Extractpdf} element={<Extractpdf />} />
              <Route path={RouteEnum.Invoice} element={<InvoiceContent />} />
              <Route element={<RequireAdmin />}>
                <Route path={RouteEnum.AdminUsers} element={<AdminUsers />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to={RouteEnum.Login} replace />} />
          </Routes>
        </Suspense>
        <Toasts />
      </Router>
    </Spin>
  );
};

RouteRegisterer.propTypes = {
  isRequesting: PropTypes.bool,
};

export { RouteRegisterer as UnConnectedRoutes };
export default RouteRegisterer;
